var ua = window.navigator.userAgent.toLowerCase(),
  ie = (/trident/gi).test(ua) || (/msie/gi).test(ua);

if(!!navigator.userAgent.match(/Trident\/7\./) || ie) {
  $('body').addClass('ie-browser');
}